import { bool, object } from "prop-types";
import React from "react";

import SimpleButton from "@components/shared/SimpleButton";

import { useTranslation } from "@lib/i18n";

import { useCurrencySettingsSelector } from "@redux/reducers/appConfig";
import { useDealSelector } from "@redux/reducers/deal";

import { CUSTOM_EVENT } from "@shared/constants";
import { getCarteGriseAmount } from "@shared/v2/lib/getCarteGriseAmount";
import { getFormattedPrice } from "@shared/v2/lib/getFormattedPrice";

const CarteGriseDetail = ({ financeSimulation, readOnly = false }) => {
  const { t } = useTranslation();
  const deal = useDealSelector();
  const currency = useCurrencySettingsSelector();

  const {
    userProfile: { registrationPostalCode },
  } = deal;

  const carteGrisePrice = getCarteGriseAmount(financeSimulation, true, false);

  const handlePostalCodeChange = () => {
    window.dispatchEvent(new CustomEvent(CUSTOM_EVENT.TRIGGER_ADDRESS_CHANGE));
  };

  if (!carteGrisePrice) {
    return null;
  }

  return (
    <div
      className={`flex flex-col items-start w-full gap-2 mt-4 ${
        !readOnly ? "border-t border-greyLight pt-4" : ""
      }`}
    >
      <div className="flex items-center justify-between w-full gap-4">
        <div className="text-black">
          {t("basket.vehicleRegistration.optionCitroen.postalCode")}
        </div>
        <div className="text-primaryDark font-semibold">
          {registrationPostalCode}
        </div>
      </div>
      <div className="flex items-center justify-between w-full gap-4">
        <div className="text-black">
          {t("basket.vehicleRegistration.optionCitroen.price")}
        </div>
        <div className="text-primaryDark font-semibold">
          {getFormattedPrice(carteGrisePrice, currency.format, currency.symbol)}
        </div>
      </div>
      {!readOnly && (
        <div className="flex items-center justify-between w-full gap-4">
          <SimpleButton
            className="m-0 px-0 py-1 underline"
            onClick={handlePostalCodeChange}
          >
            {t("basket.vehicleRegistration.optionCitroen.changeAddressButton")}
          </SimpleButton>
        </div>
      )}
    </div>
  );
};

CarteGriseDetail.propTypes = {
  financeSimulation: object,
  readOnly: bool,
};

export default CarteGriseDetail;
